import FaqBlock from "components/faqBlock/faqBlock";
import { SelfServePageData } from "../fetcher";

type TestimonialsProps = {
  data: SelfServePageData;
};

export const Faq = ({ data }: TestimonialsProps) => {
  return (
    <div className="mt-10 flex flex-col md:mt-[70px]">
      {data.faq?.length > 0 && (
        <div className={"flex flex-col gap-[60px]"}>
          <div className={"flex justify-center"}>
            <h2
              className={
                "relative font-recklessBold text-[32px] leading-[130%] after:absolute after:bottom-[-22px] after:right-[calc(50%_-_16px)] after:h-[5px] after:w-[32px] after:bg-black-rock after:content-['']"
              }
            >
              {data.faqHeading}
            </h2>
          </div>
          <FaqBlock list={data.faq} />
        </div>
      )}
    </div>
  );
};
